<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import TrainingShell from '@/features/training/TrainingShell.vue'
import UFPMTestingTab from '@/features/ufpm/components/UFPMTestingTab.vue'

const ufpmEnabled = ref(false)

function onModeChanged(event: Event): void {
  ufpmEnabled.value = !!(event as CustomEvent).detail?.enabled
}

onMounted(() => {
  ufpmEnabled.value = window.ufpmTools?.isModeEnabled?.() ?? false
  window.addEventListener('ptr:ufpm-mode-changed', onModeChanged)
})
onUnmounted(() => {
  window.removeEventListener('ptr:ufpm-mode-changed', onModeChanged)
})
</script>

<template>
  <UFPMTestingTab v-if="ufpmEnabled" />
  <TrainingShell v-else />
</template>
